import { gql } from '@apollo/client'

export const settledBetDenominationCountsFragment = gql`
  fragment SettledBetDenominationCounts on SettledBetDenominationCounts {
    one
    three
    five
    ten
    twentyfive
    fifty
    onehundred
  }
`

export const gamePlatformStatus = gql`
  ${settledBetDenominationCountsFragment}
  fragment GamePlatformStatus on GamePlatformStatus {
    game
    platform
    status
    userIdentifier
    metadata {
      character
      killsBanner
      lastUpdatedAt
      topThreeBanner
      totalMatchesBanner
      lastUserFetch
      storedMatchCount
      betsPlaced
      betsSettled
      betsRefunded
      twitchRequired
      twitchAudioMuted
      fetchFailReason
      initialFetchState
      settledBetDenominationCounts {
        ...SettledBetDenominationCounts
      }
    }
  }
`
